import React from "react"
import { RemoteStoreApi } from "./RemoteStoreTypes"

interface Props {
  store: RemoteStoreApi
}

const StoreMapStatic: React.FC<Props> = ({ store }) => {
  const { staticMapUrl } = store

  return (
    <img
      src={staticMapUrl}
      alt={`${store.name} Store location`}
      width="640px"
      height="640px"
      style={{
        width: "100%",
        height: "auto",
        borderRadius: "8px",
      }}
    />
  )
}

export default StoreMapStatic
